import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge class names (Tailwind-safe). Used by shadcn-style UI components.
 * @param  {...import("clsx").ClassValue} inputs
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
